import { createUseStyles } from "react-jss";
import { ITheme } from "../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    height: "100dvh",
    width: "100vw",
  },
  iframe: {
    paddingTop: 70,
    width: "100%",
    height: "100%",
  },
  gameContainer: {
    flex: 1,
    width: "100%",
    position: "relative",
    overflow: "hidden",
  },
  gameBox: {
    position: "relative",
    marginTop: 70,
    width: "100%",
    height: "100%",
    overflow: "hidden",
  },
}));
